"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var TypeStyle = require("typestyle");
var TabStyles_1 = require("../../styles/TabStyles");
var Declarative_1 = require("../../utils/Declarative");
var ReactHelpers_1 = require("../../utils/ReactHelpers");
var ColorPickerPresets_1 = require("./ColorPickerPresets");
var ColorSwatchSize = 15;
var ColorSwatchStyleName = TypeStyle.style({
    boxSizing: 'border-box',
    height: ColorSwatchSize,
    width: ColorSwatchSize,
    $nest: {
        '&:hover, &:active, &[aria-selected="true"]': { position: 'relative' },
        '&[aria-selected="true"]::after': { outline: "1px solid " + TabStyles_1.TabStyles.Colors.L8 },
        '&:hover::after, &:active::after': { outline: "1px solid " + TabStyles_1.TabStyles.Colors.L9 },
        '&:hover::after, &:active::after, &[aria-selected="true"]::after': {
            border: "1px solid white",
            bottom: -1,
            content: "\"\"",
            left: -1,
            pointerEvents: 'none',
            position: 'absolute',
            right: -1,
            top: -1,
        },
    }
});
exports.ColorSwatchWidget = React.forwardRef(function (props, ref) {
    var color = props.color.toLowerCase();
    var handleClick = React.useCallback(function (e) { return props.onClick(color); }, [color, props.onClick]);
    return (React.createElement("div", tslib_1.__assign({}, ReactHelpers_1.EventUtilsOptOut, { "aria-selected": props.selected, className: TypeStyle.classes(ColorSwatchStyleName, props.disabled && 'disabled'), "data-tb-test-id": Declarative_1.makeTestId(props.testId, 'ColorSwatch', color), onClick: props.disabled ? undefined : handleClick, ref: ref, style: {
            backgroundColor: color,
            height: props.size,
            width: props.size,
        } })));
});
exports.ColorSwatchWidget.displayName = 'ColorSwatchWidget';
var ColorGridType;
(function (ColorGridType) {
    ColorGridType[ColorGridType["Default"] = 0] = "Default";
    ColorGridType[ColorGridType["Minimal"] = 1] = "Minimal";
})(ColorGridType = exports.ColorGridType || (exports.ColorGridType = {}));
var ColorGridPreset;
(function (ColorGridPreset) {
    ColorGridPreset[ColorGridPreset["Dark"] = 0] = "Dark";
    ColorGridPreset[ColorGridPreset["Light"] = 1] = "Light";
    ColorGridPreset[ColorGridPreset["MaestroFlowColors"] = 2] = "MaestroFlowColors";
})(ColorGridPreset = exports.ColorGridPreset || (exports.ColorGridPreset = {}));
function getPreset(presetType) {
    switch (presetType) {
        default:
        case ColorGridPreset.Dark: return ColorPickerPresets_1.ColorPickerPresets.Dark;
        case ColorGridPreset.Light: return ColorPickerPresets_1.ColorPickerPresets.Light;
        case ColorGridPreset.MaestroFlowColors: return ColorPickerPresets_1.ColorPickerPresets.MaestroFlowColors;
    }
}
var GroupSpacingPx = 3;
var DividerHeightPx = 4;
var ColorGridWidget = /** @class */ (function (_super) {
    tslib_1.__extends(ColorGridWidget, _super);
    function ColorGridWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getColorSwatchGridBuilder = function (gridType) {
            switch (gridType) {
                default:
                case ColorGridType.Default:
                    return _this.buildDefaultColorSwatchGrid();
                case ColorGridType.Minimal:
                    return _this.buildMinimalColorSwatchGrid();
            }
        };
        return _this;
    }
    ColorGridWidget.prototype.render = function () {
        return React.createElement("div", { "data-tb-test-id": Declarative_1.makeTestId(this.props.testId, 'ColorGrid'), tabIndex: 0 }, this.getColorSwatchGridBuilder(this.props.gridType));
    };
    ColorGridWidget.prototype.buildMinimalColorSwatchGrid = function () {
        var colorsPerColumn = 4;
        var columns = [];
        var colors = getPreset(this.props.colorsPreset);
        var currentColumn = [];
        var currentGroup = [];
        var colorsInColumn = 0;
        for (var i = 0; i < colors.length; i++) {
            var color = colors[i].toLowerCase();
            var colorSwatchProps = {
                color: color,
                onClick: this.props.handleSwatchClicked,
                key: 'swatch-' + color,
                size: ColorSwatchSize,
                selected: this.props.selectedColor === color,
                disabled: this.props.disabled,
                testId: this.props.testId
            };
            currentGroup.push(React.createElement(exports.ColorSwatchWidget, tslib_1.__assign({}, colorSwatchProps)));
            colorsInColumn += 1;
            // when we reached the max number of colors in a column or we are about the add a divider, then we need to flush the group and render
            // as a div with gray borders
            if (colorsInColumn === colorsPerColumn) {
                currentColumn.push(React.createElement("div", { children: currentGroup, style: { border: "1px solid " + TabStyles_1.TabStyles.Colors.L6 }, key: 'group-' + i }));
                columns.push(React.createElement("div", { children: currentColumn, key: 'column-' + i, style: { float: 'left', marginTop: 0, marginRight: 0, marginBottom: 0, marginLeft: (columns.length ? GroupSpacingPx : 0) } }));
                currentColumn = [];
                colorsInColumn = 0;
                currentGroup = [];
            }
        }
        return React.createElement("div", { children: columns, style: { display: 'flex' } });
    };
    ColorGridWidget.prototype.buildDefaultColorSwatchGrid = function () {
        var colorsPerColumn = 6;
        var columns = [];
        var colors = getPreset(this.props.colorsPreset);
        var currentColumn = [];
        var currentGroup = [];
        var colorsInColumn = 0;
        for (var i = 0; i < colors.length; i++) {
            var color = colors[i].toLowerCase();
            var colorSwatchProps = {
                color: color,
                onClick: this.props.handleSwatchClicked,
                key: 'swatch-' + color,
                size: ColorSwatchSize,
                selected: this.props.selectedColor === color,
                disabled: this.props.disabled,
                testId: this.props.testId
            };
            currentGroup.push(React.createElement(exports.ColorSwatchWidget, tslib_1.__assign({}, colorSwatchProps)));
            colorsInColumn += 1;
            // for the first 2 columns (gray colors) we will have a divider after the first color swatch, after that the divider is after the 3rd
            var addDivider = colorsInColumn === 1 && columns.length < 2 || colorsInColumn === 3 && columns.length >= 2;
            // when we reached the max number of colors in a column or we are about the add a divider, then we need to flush the group and render
            // as a div with gray borders
            if (colorsInColumn === colorsPerColumn || addDivider) {
                currentColumn.push(React.createElement("div", { children: currentGroup, style: { border: "1px solid " + TabStyles_1.TabStyles.Colors.L6 }, key: 'group-' + i }));
                if (addDivider) {
                    currentColumn.push(React.createElement("div", { style: { width: ColorSwatchSize, height: DividerHeightPx }, key: 'divider-' + i }));
                }
                if (colorsInColumn === colorsPerColumn) {
                    columns.push(React.createElement("div", { children: currentColumn, key: 'column-' + i, style: { float: 'left', marginTop: 0, marginRight: 0, marginBottom: 0, marginLeft: (columns.length ? GroupSpacingPx : 0) } }));
                    currentColumn = [];
                    colorsInColumn = 0;
                }
                currentGroup = [];
            }
        }
        return React.createElement("div", { children: columns, style: { display: 'flex' } });
    };
    ColorGridWidget.defaultProps = { colorsPreset: ColorGridPreset.Dark };
    return ColorGridWidget;
}(React.Component));
exports.ColorGridWidget = ColorGridWidget;
//# sourceMappingURL=ColorGridWidget.js.map